export function clearContainer(container: HTMLElement) {
  if (!container) return;
  if (container.childNodes.length === 0) {
    return;
  }

  while (container.firstChild) {
    container.removeChild(container.firstChild);
  }
}
